<template>
  <div>
    <div class="home">
      <img alt="Vue logo" src="../assets/images/vue-logo.png">
      <HelloWorld msg="Welcome to Your Vue.js App" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: { Header, HelloWorld }
};
</script>
